<p-tabs [(value)]="activeTab">
  <p-tablist>
    <p-tab value="messkriterien">{{ 'CHOP.TAB_MESSKRITERIEN' | translate }}</p-tab>
    <p-tab value="massnahmen">{{ 'CHOP.TAB_MASSNAHMEN' | translate }}</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="messkriterien">
      <app-table
        [actionColumnWidth]="400"
        [columns]="messkriterienColumns"
        [loading]="loading"
        [value]="messkriterien"
        filename="CHOP.MESSKRITERIEN"
        sortField="mindestAnzahl">
        <ng-template
          (onClick)="showCreateMesskriterium()"
          appToolbarButton
          icon="fal fa-plus"
          labelKey="CHOP.CREATE_MESSKRITERIUM"></ng-template>
        <ng-template
          (onClick)="openMesskriteriumDetail($event.row)"
          appActionButton
          icon="fal fa-search"
          labelKey="GLOBAL.DETAILS"></ng-template>
        <ng-template
          (onClick)="showEditMesskriterium($event.row)"
          appActionButton
          icon="fal fa-pencil"
          labelKey="ACTIONS.EDIT"></ng-template>
        <ng-template
          (onClick)="deleteMesskriterium($event.row)"
          appActionButton
          icon="fal fa-trash"
          labelKey="ACTIONS.DELETE"
          type="danger"></ng-template>
      </app-table>
    </p-tabpanel>
    <p-tabpanel value="massnahmen">
      <app-table
        [actionColumnWidth]="400"
        [columns]="massnahmenColumns"
        [loading]="loading"
        [value]="massnahmenRows"
        filename="CHOP.MASSNAHMEN"
        sortField="tacsId">
        <ng-template
          (onClick)="showAddMassnahmeDialog()"
          appToolbarButton
          icon="fal fa-plus"
          labelKey="CHOP.CREATE_MASSNAHME"></ng-template>
        <ng-template
          (onClick)="removeMassnahme($event.row)"
          appActionButton
          icon="fal fa-trash"
          labelKey="ACTIONS.DELETE"
          type="danger"></ng-template>
      </app-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
